var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
const SvgComponent = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 32,
  height: 32,
  viewBox: "0 0 32 32"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "Grupo_254",
  "data-name": "Grupo 254",
  transform: "translate(-1511 -666)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Grupo_252",
  "data-name": "Grupo 252",
  transform: "translate(154 25)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Grupo_251",
  "data-name": "Grupo 251",
  transform: "translate(1365 648)"
}, /*#__PURE__*/React.createElement("circle", {
  id: "Elipse_37",
  "data-name": "Elipse 37",
  cx: 16,
  cy: 16,
  r: 16,
  transform: "translate(-8 -7)",
  fill: "#eee9ff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Caminho_468",
  "data-name": "Caminho 468",
  d: "M8.97,16.2H6.131a.566.566,0,0,1-.562-.562V11.805A1.419,1.419,0,0,1,6.985,10.39H8.97a.566.566,0,0,1,.562.562v4.68A.567.567,0,0,1,8.97,16.2ZM6.693,15.078H8.408V11.521H6.985a.292.292,0,0,0-.292.292Z",
  transform: "translate(-2.335 -3.546)",
  fill: "#db56e0"
}), /*#__PURE__*/React.createElement("path", {
  id: "Caminho_469",
  "data-name": "Caminho 469",
  d: "M12.75,15.061H9.912A.566.566,0,0,1,9.35,14.5V7.265A1.419,1.419,0,0,1,10.765,5.85H11.9a1.419,1.419,0,0,1,1.415,1.415V14.5A.572.572,0,0,1,12.75,15.061Zm-2.269-1.123H12.2V7.265a.292.292,0,0,0-.292-.292H10.765a.292.292,0,0,0-.292.292v6.672Z",
  transform: "translate(-3.284 -2.405)",
  fill: "#db56e0"
}), /*#__PURE__*/React.createElement("path", {
  id: "Caminho_470",
  "data-name": "Caminho 470",
  d: "M16.54,16.63H13.7a.566.566,0,0,1-.562-.562V12.662A.566.566,0,0,1,13.7,12.1h1.984A1.419,1.419,0,0,1,17.1,13.515v2.554A.561.561,0,0,1,16.54,16.63Zm-2.276-1.123h1.715V13.515a.292.292,0,0,0-.292-.292H14.263Z",
  transform: "translate(-4.236 -3.975)",
  fill: "#db56e0"
}), /*#__PURE__*/React.createElement("path", {
  id: "Caminho_471",
  "data-name": "Caminho 471",
  d: "M11.547,17.35H7.054c-4.066,0-5.8-1.737-5.8-5.8V7.054c0-4.066,1.737-5.8,5.8-5.8h4.493c4.066,0,5.8,1.737,5.8,5.8v4.493C17.35,15.613,15.613,17.35,11.547,17.35ZM7.054,2.373c-3.452,0-4.68,1.228-4.68,4.68v4.493c0,3.452,1.228,4.68,4.68,4.68h4.493c3.452,0,4.68-1.228,4.68-4.68V7.054c0-3.452-1.228-4.68-4.68-4.68Z",
  transform: "translate(-1.25 -1.25)",
  fill: "#db56e0"
}))))));
export default __webpack_public_path__ + "static/media/bars_active.99687175.svg";
export { SvgComponent as ReactComponent };